export class Role {
  name: string
  displayName: string
  // list of rights?
}

export enum BaseRoles {
  USER = 'USER',
  ADMIN = 'ADMIN'
}
